module.exports = __webpack_public_path__ + "img/aziz-final.a32a2f7d.png";